import { Stepper } from "@chakra-ui/react";
import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  .login {
    display: flex;
  }
  .right {
    width: 50%;
    position: relative;

    h1 {
      text-align: center;
      font-size: 3.1875rem;
      margin-top: 4.375rem;
      font-weight: 300;
      font-family: "Bellefair", serif;
      color: #3f3d56;
    }

    .imag {
      width: 800px;
      height: 400px;
      position: absolute;
      bottom: -3.2rem;
      left: 30%;
    }
  }

  .left {
    width: 50vw;
    height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;

    .imag {
      padding: 50px 0 10px 0;
      img {
        width: 9.375rem;
        height: 9.375rem;
      }
    }
    .email {
      width: 20.3125rem;
    }
    .btn_entrar {
      width: 22.625rem;
      padding: 0.3125rem;
      background-color: #3f3d56;
      color: #ffffff;
      border-radius: 8px;
      margin-top: 2.1875rem;
      &:hover {
        background-color: #343341;
      }
    }

    .link_esq_senha {
      display: block;
      margin-top: 13px;
      text-align: center;
      color: #1a57f2;
      text-decoration: underline;
    }

    .btn_cadastro {
      display: flex;
      width: 12.5rem;
      margin: 1.5625rem auto;
      padding: 0.1875rem;
      background-color: #efeffd;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
    }

    .icon {
      margin-right: 12px;
    }
  }

  .footer {
    width: 100%;
    height: 20vh;
    display: flex;
    align-items: flex-end;
    background-color: #d9485d;

    footer {
      width: 100vw;
      font-size: 0.6875rem;
      color: #ffffff;
      display: flex;
      justify-content: center;
      margin-bottom: 0.5rem;

       p {
  
      }
    }
  }

  .label-erro {
    display: block;
    color: #d9485d;
    font-size: 0.8125rem;
  }

  @media screen and (max-width: 1490px) {
    .right {
      .imag {
        left: 25%;
      }
    }
  }

  @media screen and (max-width: 1400px) {
    .right {
      .imag {
        left: 19%;
      }
    }
  }

  @media screen and (max-width: 1260px) {
    .right {
      .imag {
        left: -2rem;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .right {
      display: none;
    }
    .left {
      align-items: center;
      width: 100vw;
    }
    .footer {
      footer {
        span {
          position: absolute;
          right: 35%;
        }
      }
    }
  }

  @media screen and (max-width: 700px) {
    .footer {
      footer {
        span {
          right: 30%;
        }
      }
    }
  }

  @media screen and (max-width: 460px) {
    .footer {
      footer {
        span {
          right: 15%;
        }
      }
    }
  }

  @media screen and (max-width: 1400px) and (max-height: 768px) {
    .right {
      h1 {
        font-size: 2rem;
      }
    }

    .footer {
      footer {
        span {
          top: 6.25rem;
        }
      }
    }
  }

  @media screen and (max-width: 393px) and (max-height: 851px) {
    .footer {
      footer {
        span {
          top: 8.3rem;
        }
      }
    }
  }
`;

export const SytelyStteper = styled(Stepper)`
  display: flex;

  @media screen and (max-width: 590px) {
    flex-wrap: wrap;
  }
`;
